import { connect } from "react-redux";
import CrystalPage from "./template";

const mapDispatchToProps = (dispatch) => ({
  openRequestDemoForm: () => dispatch({ type: "OPEN_REQUEST_DEMO_FORM" }),
});

const ConnectedCrystalPage = connect(
  null,
  mapDispatchToProps
)(CrystalPage);

export default ConnectedCrystalPage;



// WEBPACK FOOTER //
// ./src/pages/crystal/index.js